import React from "react";
import {NavLink, withRouter} from "react-router-dom";

import {
  ROUTER_MEMBERS,
  ROUTER_MESSAGE,
  ROUTER_ROOT
} from "../constants/routers";


export class Navbar extends React.Component {

    render() {
      const menuLinks = [
        {
          icon: "fa-list-alt",
          text: __("Diary"),
          route: ROUTER_ROOT,
          indicator: true,
          exact: true,
          page: 'Timeline'
        },
        {
          icon: "fa-envelope",
          text: __("Messages"),
          route: ROUTER_MESSAGE,
          indicator: false,
          exact: false,
          page: 'Messages'
        },
        {
          icon: "fa-users",
          text: __("Members"),
          route: ROUTER_MEMBERS,
          indicator: false,
          exact: false,
          page: 'Members'
        }
      ].map((obj, i) => {
        return (
          <li key={i}>
            <NavLink
              to={obj.route}
              exact={obj.exact}
              className='flexBox center-center'
            >
              <i className={`fa ${obj.icon}`} />
              {obj.indicator && <i className="redCircle" />}
              {obj.text}
            </NavLink>
          </li>
        );
      });

      return (
        <header className="navbar flexBox center-center" id="navBar">
          <div className="brand flex">
            <span>Familien Portal</span>
            <span className="description">media4care</span>
          </div>
          <nav>
            <ul className="flexBox direction-row space-around">
              {menuLinks}
            </ul>
          </nav>
          <div className="flex spacer" />
        </header>
      );
    }
  }

export default withRouter(Navbar);
